import React from "react";
import { Commend3PrimaryButton, Commend3SecondaryButton } from "./Commend3Modal";

type Commend3ConfirmDialogProps = {
  isOpen: boolean;
  id: string;
  title: string;
  body: string;
  actionLabel: string;
  busyLabel?: string;
  busy?: boolean;
  danger?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const svgBase = {
  stroke: "currentColor",
  fill: "none",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

const TrashIcon = () => (
  <svg viewBox="0 0 24 24" className="tw-h-[19px] tw-w-[19px]" style={svgBase} aria-hidden="true">
    <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M10 11v6M14 11v6" />
  </svg>
);

const WarnIcon = () => (
  <svg viewBox="0 0 24 24" className="tw-h-[19px] tw-w-[19px]" style={svgBase} aria-hidden="true">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);

const Commend3ConfirmDialog = ({
  isOpen,
  id,
  title,
  body,
  actionLabel,
  busyLabel,
  busy,
  danger,
  onCancel,
  onConfirm,
}: Commend3ConfirmDialogProps) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="tw-fixed tw-inset-0 tw-z-[300]"
        style={{ background: "rgba(11,12,35,.5)" }}
        onClick={onCancel}
      />
      <div
        id={id}
        className="tw-fixed tw-left-1/2 tw-top-1/2 tw-z-[301] tw-w-[440px] tw-max-w-[92vw] tw-overflow-hidden tw-rounded-xl tw-bg-white"
        style={{
          transform: "translate(-50%,-50%)",
          border: "0.5px solid #E3E5EC",
          boxShadow: "0 24px 48px rgba(3,5,98,.22)",
        }}
        role="dialog"
        aria-label={title}
      >
        <div className="tw-flex tw-items-start tw-gap-[13px] tw-px-[22px] tw-pb-4 tw-pt-[22px]">
          <div
            className="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg"
            style={
              danger
                ? { background: "#FEE9EC", color: "#D60027" }
                : { background: "#FEF3C7", color: "#B45309" }
            }
          >
            {danger ? <TrashIcon /> : <WarnIcon />}
          </div>
          <div className="tw-min-w-0 tw-flex-1">
            <div className="tw-mb-1.5 tw-text-[15px] tw-font-semibold tw-text-[#0B0C23]">
              {title}
            </div>
            <div className="tw-text-[13px] tw-text-[#59596E]" style={{ lineHeight: 1.6 }}>
              {body}
            </div>
          </div>
        </div>
        <div
          className="tw-flex tw-justify-end tw-gap-2 tw-px-[22px] tw-py-[13px]"
          style={{ borderTop: "0.5px solid #E3E5EC", background: "#FAFBFD" }}
        >
          <Commend3SecondaryButton id={`${id}-cancel`} onClick={onCancel} disabled={busy}>
            Cancel
          </Commend3SecondaryButton>
          <Commend3PrimaryButton
            id={`${id}-confirm`}
            onClick={onConfirm}
            disabled={busy}
            danger={danger}
          >
            {busy && busyLabel ? busyLabel : actionLabel}
          </Commend3PrimaryButton>
        </div>
      </div>
    </>
  );
};

export default Commend3ConfirmDialog;
